<template>
  <IconSlideButton :label :icon severity="success" :colorClass="successColorClass" :type :form :disabled></IconSlideButton>
</template>

<script setup lang="ts">
interface Props {
  label?: string;
  type?: "submit" | "reset" | "button";
  form?: string;
  icon?: string;
  disabled?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  label: "Save",
  type: "submit",
  icon: "check",
  disabled: false,
});

const successColorClass = ref<string>("bg-success-500/20 hover:shadow-success-500/50 hover:bg-success-500!");
</script>
